import { Navigate } from "react-router-dom";
import { useStaffAuth } from "../context/StaffAuthContext";

const ModuleGuard = ({ moduleCode, children }) => {
  const { loading, staff, hasModule } = useStaffAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950 text-neutral-500 dark:text-neutral-400">
        Loading...
      </div>
    );
  }

  if (!staff) {
    return <Navigate to="/employee-login" replace />;
  }

  if (!hasModule(moduleCode)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950">
        <div className="bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 shadow-card dark:shadow-card-dark rounded-card p-8 max-w-md w-full mx-4">
          <h2 className="text-xl font-bold text-danger-500 dark:text-danger-500">
            Access Denied
          </h2>
          <p className="mt-2 text-neutral-600 dark:text-neutral-300 text-sm">
            You do not have access to this module.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default ModuleGuard;
